/** @format */

import {
	ComponentFactory,
	ComponentFactoryResolver,
	CUSTOM_ELEMENTS_SCHEMA,
	NgModule,
	NO_ERRORS_SCHEMA
} from '@angular/core';
import {
	homefieldIconBuildingStoreDsgAlt,
	homefieldIconFulfillmentPickupFilled,
	homefieldIconFulfillmentPickupOutlined,
	homefieldIconFulfillmentSamedayFilled,
	homefieldIconFulfillmentSamedayOutlined,
	homefieldIconFulfillmentShippingFilled,
	homefieldIconFulfillmentShippingOutlined,
	HomefieldIconLibraryModule,
	homefieldIconOrderDelivery,
	HomefieldIconsLibraryService
} from '@dsg-tech/homefield-angular-icons';

import { ChangeStoreButtonModule } from '../change-store-button/change-store-button.module';
import { ChangeZipCodeButtonModule } from '../change-zip-code-button/change-zip-code-button.module';
import { CommonModule } from '@angular/common';
import { CommonTimerModule } from '@shared/components';
import { FulfillmentButtonSubtextComponent } from './fulfillment-button-subtext/fulfillment-button-subtext.component';
import { HmfActionTextComponent, HmfSidePanelComponent } from '@dsg-tech/homefield-angular';
import { InStorePickupButtonComponent } from './in-store-pickup-button/in-store-pickup-button.component';
import { InStorePickupSubTextComponent } from './fulfillment-button-subtext/in-store-pickup-subtext/in-store-pickup-subtext.component';
import { SameDayDeliveryButtonComponent } from './same-day-delivery-button/same-day-delivery-button.component';
import { SameDayDeliverySubtextComponent } from './fulfillment-button-subtext/same-day-delivery-subtext/same-day-delivery-subtext.component';
import { ShipToMeButtonComponent } from './ship-to-me-button/ship-to-me-button.component';
import { ShipToMeSubtextComponent } from './fulfillment-button-subtext/ship-to-me-subtext/ship-to-me-subtext.component';
import { ResizeDeviceBreakPointDirective } from '@shared/utils/directives';
import { PdpFulfillmentButtonComponent } from '../ui/fulfillment-button/fulfillment-button.component';

@NgModule({
	declarations: [
		FulfillmentButtonSubtextComponent,
		InStorePickupButtonComponent,
		InStorePickupSubTextComponent,
		SameDayDeliveryButtonComponent,
		SameDayDeliverySubtextComponent,
		ShipToMeButtonComponent,
		ShipToMeSubtextComponent
	],
	imports: [
		ChangeStoreButtonModule,
		ChangeZipCodeButtonModule,
		CommonModule,
		CommonTimerModule,
		HmfActionTextComponent,
		HmfSidePanelComponent,
		HomefieldIconLibraryModule,
		PdpFulfillmentButtonComponent,
		ResizeDeviceBreakPointDirective
	],
	exports: [
		FulfillmentButtonSubtextComponent,
		InStorePickupButtonComponent,
		SameDayDeliveryButtonComponent,
		ShipToMeButtonComponent
	],
	schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA]
})
export class FulfillmentButtonsModule {
	constructor(
		private resolver: ComponentFactoryResolver,
		homefieldIconsLibraryService: HomefieldIconsLibraryService
	) {
		homefieldIconsLibraryService.registerIcons([
			homefieldIconOrderDelivery,
			homefieldIconBuildingStoreDsgAlt,
			homefieldIconFulfillmentPickupFilled,
			homefieldIconFulfillmentPickupOutlined,
			homefieldIconFulfillmentSamedayFilled,
			homefieldIconFulfillmentSamedayOutlined,
			homefieldIconFulfillmentShippingFilled,
			homefieldIconFulfillmentShippingOutlined
		]);
	}

	public resolveComponentFactory(): ComponentFactory<FulfillmentButtonsModule> {
		return this.resolver.resolveComponentFactory(FulfillmentButtonsModule);
	}
}
